export enum ROUTES {
  PROGRAM_INDEX = '/organizations/:orgId(\\d+)/programs',
  PROGRAM_SEASONS = '/organizations/:orgId(\\d+)/programs/:programId(\\d+)',
  PROGRAM_NEW = '/organizations/:orgId(\\d+)/programs/new',
  PROGRAM_EDIT = '/organizations/:orgId(\\d+)/programs/:programId(\\d+)/edit',
  PROGRAM_REPORT = '/organizations/:orgId(\\d+)/programs-report',
  CALENDAR = '/organizations/:orgId(\\d+)/calendar',
  MEMBER_INDEX = '/organizations/:orgId(\\d+)/members',
  MEMBER_NEW = '/organizations/:orgId(\\d+)/members/new',
  MEMBER = '/organizations/:orgId(\\d+)/members/:memberId(\\d+)/:memberTab(participation|history|invoices|registrations)?',

  MEMBER_BACKGROUND_CHECK_NEW = '/organizations/:orgId(\\d+)/members/background/new',
  DIVISION_INDEX = '/organizations/:orgId(\\d+)/divisions',

  STAFF_INDEX = '/organizations/:orgId(\\d+)/staff',
  STAFF_NEW = '/organizations/:orgId(\\d+)/staff/new',
  STAFF_EDIT = '/organizations/:orgId(\\d+)/staff/:staffId',
  STAFF_BACKGROUND_CHECK_NEW = '/organizations/:orgId(\\d+)/staff/background/new',

  SETTINGS_INDEX = '/organizations/:orgId(\\d+)/settings',
  MERCHANT_ACCOUNTS = '/organizations/:orgId(\\d+)/settings/merchant-accounts',

  INVOICES_INDEX = '/organizations/:orgId(\\d+)/invoices',

  MESSAGE_INDEX = '/organizations/:orgId(\\d+)/messages',
  MESSAGE_NEW = '/organizations/:orgId(\\d+)/messages/new',
  MESSAGE_SENT = '/organizations/:orgId(\\d+)/messages/sent/:emailId',
  MESSAGE_EDIT = '/organizations/:orgId(\\d+)/messages/edit/:emailId',
  PARTICIPANTS_INDEX = '/organizations/:orgId(\\d+)/programs/:programId(\\d+)/seasons/:seasonId(\\d+)/participants',
  FINANCIALS = '/organizations/:orgId(\\d+)/financials/:reportType(outstanding|transactions|deposits)?',
  ORDER_DETAILS = '/organizations/:orgId(\\d+)/financials/order/:orderId/details',
  PARTICIPANT = '/organizations/:orgId(\\d+)/programs/:programId(\\d+)/seasons/:seasonId(\\d+)/participants/:memberId(\\d+)',

  REGISTRATION_INDEX = '/organizations/:orgId(\\d+)/registration/:formId?/:step(\\d+)?',
  REGISTRATION_DETAILS = '/organizations/:orgId(\\d+)/registration/:registrationId(\\d+)/details',
  HISTORICAL_SEASONS = '/organizations/:orgId(\\d+)/historical-seasons',

  SPONSORSHIPS = '/organizations/:orgId(\\d+)/sponsorships',
  TOURNAMENTS = '/organizations/:orgId(\\d+)/tournaments',
  WEBSITES = '/organizations/:orgId(\\d+)/websites',
  COACHES_PACK = '/organizations/:orgId(\\d+)/coaches-pack',

  SEASON_REGISTRATIONS_INDEX = '/organizations/:orgId(\\d+)/programs/:programId(\\d+)/seasons/:seasonId(\\d+)/registration',

  SEASON_FINANCIALS = '/organizations/:orgId(\\d+)/programs/:programId(\\d+)/seasons/:seasonId(\\d+)/financials',

  FORBIDDEN = '/forbidden',
  DISABLED_ORG = '/disabled/:orgId(\\d+)',
  HOME = '/',
}

export const ROUTES_LIST: string[] = Object.entries(ROUTES).map(([_key, value]) => value);
